<template>
	<Layout>
		<div class="l-container">
			<div class="l-row l-align-center">
				<div class="l-col l-col--12 l-col--8@lg">
					<section class="s-html l-content-section -reduced-spacing u-mt-7">
						<h1 class="title">
							{{ $I18n.trans('cookies.cookie_info.title') }}
						</h1>
						<!-- eslint-disable vue/no-v-html -->
						<div v-html="$I18n.trans('cookies.cookie_info.description')" />
						<!-- eslint-enable -->
					</section>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';

export default {
	name:       'ViewCookies',
	components: { Layout },
	mounted() {
		window.openCookieConsent = () => {
			this.eventBus.$emit('openCookieConsent');
		};
	},
};
</script>

<style>

</style>
